import { createShallowStore, createStore } from '@frontend/store';

interface DeleteConfirmationStore {
  skipFaxDeleteConfirmation: boolean;
  skipDraftDeleteConfirmation: boolean;
  setSkipFaxDeleteConfirmation: (value: boolean) => void;
  setSkipDraftDeleteConfirmation: (value: boolean) => void;
}

export const useDeleteConfirmationStore = createStore<DeleteConfirmationStore>(
  (set) => ({
    skipFaxDeleteConfirmation: false,
    skipDraftDeleteConfirmation: false,
    setSkipFaxDeleteConfirmation: (value) =>
      set((state) => {
        state.skipFaxDeleteConfirmation = value;
      }),
    setSkipDraftDeleteConfirmation: (value) =>
      set((state) => {
        state.skipDraftDeleteConfirmation = value;
      }),
  }),
  { name: 'FaxDeleteConfirmation' }
);

export const useDeleteConfirmationShallowStore = createShallowStore(useDeleteConfirmationStore);
